import CoachingLandingPage from '../../js/pages/CoachingLandingPage';

export default CoachingLandingPage;
